import { Node, mergeAttributes } from '@tiptap/core';
const HardBreak = Node.create({
  name: 'hardBreak',
  addOptions() {
    return {
      keepMarks: true,
      HTMLAttributes: {}
    };
  },
  inline: true,
  group: 'inline',
  selectable: false,
  parseHTML() {
    return [{
      tag: 'br'
    }];
  },
  renderHTML(_ref) {
    let {
      HTMLAttributes
    } = _ref;
    return ['br', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  renderText() {
    return '\n';
  },
  addCommands() {
    return {
      setHardBreak: () => _ref2 => {
        let {
          commands,
          chain,
          state,
          editor
        } = _ref2;
        return commands.first([() => commands.exitCode(), () => commands.command(() => {
          const {
            selection,
            storedMarks
          } = state;
          if (selection.$from.parent.type.spec.isolating) {
            return false;
          }
          const {
            keepMarks
          } = this.options;
          const {
            splittableMarks
          } = editor.extensionManager;
          const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
          return chain().insertContent({
            type: this.name
          }).command(_ref3 => {
            let {
              tr,
              dispatch
            } = _ref3;
            if (dispatch && marks && keepMarks) {
              const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
              tr.ensureMarks(filteredMarks);
            }
            return true;
          }).run();
        })]);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => this.editor.commands.setHardBreak(),
      'Shift-Enter': () => this.editor.commands.setHardBreak()
    };
  }
});
export { HardBreak, HardBreak as default };